import { TemplatesList } from '@/components/templates';
import { PageContainer } from '@startupquickstart/frontend';

const breadcrumbs = [
  { label: 'Home', href: '/' },
  { label: 'Game Templates', current: true },
];

export function TemplatesPage() {
  return (
    <PageContainer>
      <TemplatesList breadcrumbs={breadcrumbs} />
    </PageContainer>
  );
}
